var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69063 20.2509H4.5C4.30109 20.2509 4.11033 20.1719 3.96967 20.0312C3.82902 19.8906 3.75 19.6998 3.75 19.5009V15.3103C3.74966 15.2129 3.76853 15.1164 3.80553 15.0263C3.84253 14.9362 3.89694 14.8543 3.96563 14.7853L15.2156 3.53527C15.2854 3.46441 15.3686 3.40813 15.4603 3.36972C15.5521 3.33131 15.6505 3.31152 15.75 3.31152C15.8495 3.31152 15.9479 3.33131 16.0397 3.36972C16.1314 3.40813 16.2146 3.46441 16.2844 3.53527L20.4656 7.71652C20.5365 7.78631 20.5928 7.86949 20.6312 7.96123C20.6696 8.05297 20.6894 8.15144 20.6894 8.25089C20.6894 8.35035 20.6696 8.44882 20.6312 8.54056C20.5928 8.6323 20.5365 8.71548 20.4656 8.78527L9.21563 20.0353C9.1466 20.104 9.06469 20.1584 8.9746 20.1954C8.88452 20.2324 8.78802 20.2512 8.69063 20.2509V20.2509Z",
    stroke: "#101828",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6L18 11.25",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.2ce24eec578e05cf4c00f0ab598903e7.svg";
export { ForwardRef as ReactComponent };